import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Container,
  Typography,
  CircularProgress,
  Box,
  Button
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';

import DashboardLayout from '../../Sidebar/DashboardLayout';
import GenericTable from '../../../commun/GenericTable';
import ActionButtons from '../../../commun/ActionButtons';
import { showDeleteConfirmation } from '../../../commun/deletemsg'; 
import './emailTemplates.css';
import Chatbox from '../../../commun/ChatBox';

const EmailTemplates = () => {
  const [displayMode, setDisplayMode] = useState('table');

  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const userRole = localStorage.getItem('userType');
  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = () => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/email-templates`)
      .then((res) => setTemplates(res.data))
      .catch(() => setTemplates([]))
      .finally(() => setLoading(false));
  };

  const handleDelete = (id) => {
    showDeleteConfirmation({
      onConfirm: async () => {
        try {
          await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/admin/email-templates/${id}`);
          fetchTemplates();
        } catch (error) {
          alert("Erreur lors de la suppression.");
        }
      },
      onCancel: () => {
      }
    });
  };

  const columns = [
    { key: 'nom', label: 'Nom' },
    { key: 'sujet', label: 'Sujet' },
    { key: 'type', label: 'Type', render: (val) => val.toUpperCase() }
  ];

  const renderActions = (row) => (
    <ActionButtons
      showView={false}
      onEdit={() => navigate(`/admin/email-templates/${row._id}`)}
      onDelete={() => handleDelete(row._id)}
    />
  );

  return (
    <DashboardLayout>
      <Container maxWidth="lg">
        <Box className="email-template-header">
          <Typography variant="h4" className="email-template-title">
            Modèles d'e-mails
          </Typography>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => navigate('/admin/email-templates/add')}
          >
            Ajouter un modèle
          </Button>
        </Box>

        {loading ? (
          <Box display="flex" justifyContent="center" mt={4}>
            <CircularProgress />
          </Box>
        ) : (
          <GenericTable columns={columns} data={templates} renderActions={renderActions}   displayMode={displayMode}
  setDisplayMode={setDisplayMode} />
        )}
      </Container>
      {userRole !== 'agent' && <Chatbox userRole={userRole} />}
    </DashboardLayout>
  );
};

export default EmailTemplates;
